import { render, staticRenderFns } from "./OriImage.vue?vue&type=template&id=ac4a6766&scoped=true&"
import script from "./OriImage.vue?vue&type=script&lang=js&"
export * from "./OriImage.vue?vue&type=script&lang=js&"
import style0 from "./OriImage.vue?vue&type=style&index=0&id=ac4a6766&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac4a6766",
  null
  
)

export default component.exports